<div class="_top-bar">
  <div class="_logo-outer">
    <a (click)="goToLandingPage()"><img
        class="_logo"
        src="assets/images/logo.png"
      /></a>
  </div>
  <div class="flex items-center justify-between">
    <div class="_app-name">
      @if (hasSidebar) {
      <p-button
        class="_menu-btn mr-2"
        icon="pi pi-bars"
        [text]="true"
        [plain]="true"
        (onClick)="onToggleSidebar()"
      ></p-button>
      }
      <a (click)="goToLandingPage()">
        <img
          class="_logo-inner _logo"
          src="assets/images/logo.png"
        /></a>
    </div>
    <div class="_user-section">
      <p-menu
        #menu
        [model]="items"
        [popup]="true"
      />
      <p-button
        [text]="true"
        (onClick)="menu.toggle($event)"
        [plain]="true"
      >

        @if(userData.imageUrl){
        <img
          class="_image-profile "
          [src]="userData.imageUrl"
        />
        }@else {
        <p-avatar
          icon="pi pi-user"
          styleClass="mr-2"
          size="normal"
          shape="circle"
        />
        }

        <div class="flex flex-col items-stretch text-left leading-tight">
          <div class="flex flex-row items-center justify-between">
            <span class="font-bold">{{ userData.firstname}} {{ userData.lastname}}</span>
            <i class="pi pi-chevron-down ml-2"></i>
          </div>

          @if(userRoles.role){
          <span class="text-sm font-semibold">{{userGroupEnumTex[userRoles.userGroup]}}</span>
          }

          @if(userRoles.branch){
          <span class="text-xs">{{userRoles.branch.branchName}}</span>
          }

        </div>


      </p-button>
    </div>
  </div>
</div>